import { modifier } from 'ember-modifier'
import { isSafari } from 'customer-flows/utils/is-safari'

// safari: position:fixed inside overflow: auto is treated as position: absolute relative to the scroll container
// il-tooltip calculates popup coordinates using getBoundingClientRect() then applies them
// as position:fixed; in safari those same values are interpreted as scroll-container-relative, so the popup
// is offset by scrollTop - containerRect.top; here we patch calculateTooltipPosition on the instance to correct this
export default modifier((element: HTMLElement) => {
  if (!isSafari()) return

  let parent = element.parentElement
  let scrollContainer: HTMLElement | null = null

  while (parent && parent !== document.documentElement) {
    const { overflow, overflowY } = getComputedStyle(parent)

    if (/auto|scroll/.test(overflow) || /auto|scroll/.test(overflowY)) {
      scrollContainer = parent
      break
    }

    parent = parent.parentElement
  }

  if (!scrollContainer) return

  const tooltipEl = element as any
  let originalCalcPosition: (() => void) | undefined
  let originalMouseenter: ((disable?: boolean) => void) | undefined

  const raf = requestAnimationFrame(() => {
    originalCalcPosition = tooltipEl.calculateTooltipPosition
    if (!originalCalcPosition) return

    tooltipEl.calculateTooltipPosition = () => {
      originalCalcPosition!.call(tooltipEl)

      const wrapper = tooltipEl.shadowRoot?.getElementById('tooltip-wrapper') as HTMLElement | null
      if (!wrapper || !wrapper.style.top) return

      const containerRect = scrollContainer!.getBoundingClientRect()
      const top = parseFloat(wrapper.style.top)
      const left = parseFloat(wrapper.style.left)

      if (!isNaN(top)) wrapper.style.top = `${top + scrollContainer!.scrollTop - containerRect.top}px`
      if (!isNaN(left)) wrapper.style.left = `${left + scrollContainer!.scrollLeft - containerRect.left}px`
    }

    // Prevent empty tooltip bubble on Safari when tooltipText is not yet set
    originalMouseenter = tooltipEl.mouseenterTooltip

    if (originalMouseenter) {
      tooltipEl.mouseenterTooltip = (_disable?: boolean) => {
        if (!tooltipEl.tooltipText) return
        originalMouseenter!.call(tooltipEl, _disable)
      }
    }
  })

  return () => {
    cancelAnimationFrame(raf)

    if (originalCalcPosition) {
      tooltipEl.calculateTooltipPosition = originalCalcPosition
    }

    if (originalMouseenter) {
      tooltipEl.mouseenterTooltip = originalMouseenter
    }
  }
})
